import React, { useState } from 'react';
import Autenticacion from './Autenticación';
import { useAuth } from '../AuthContext';
import { useCart } from '../CartContext';
import '../stylesheets/HomePage.css';
import MZ from '../img/Icons/MarketZ.png';
import Carrito from '../img/Icons/ShoppingCart.png';
import Control from '../img/Icons/Usados1.png';
import Guitar from '../img/Icons/Usados2.png';
import Bolsa1 from '../img/Icons/Bolsas1.png';
import Bolsa2 from '../img/Icons/Bolsas2.png';
import Paper1 from '../img/Icons/paper1.png';
import Paper2 from '../img/Icons/paper2.png';
import Items from './Items';
import AddProduct from './AddProduct';
import ShoppingCart from './ShoppingCart';

const MainPage = () => {
  const { user, logout } = useAuth();
  const { cartItems, setCartItems } = useCart();
  const [authModal, setAuthModal] = useState({ view: null, isVisible: false });
  const [showCart, setShowCart] = useState(false);

  const handleAuthView = (view) => setAuthModal({ view, isVisible: true });
  const handleCloseAuth = () => setAuthModal({ view: null, isVisible: false });
  const handleLogout = async () => {
    await logout(setCartItems);
  };

  const handleCartView = () => setShowCart(!showCart);

  return (
    <div className='market-zeta'>
      <div className={`blur-effect ${authModal.isVisible ? 'active' : ''}`}></div>

      {authModal.isVisible && (
        <Autenticacion authView={authModal.view} onClose={handleCloseAuth} />
      )}

      <header>
        <div className='Icon-Search-Container'>
          <div className='MKZ-Name-Cont'>
            <img src={MZ} alt='Market Z Logo' className='MKZ-Icon' />
            <h1 className='MKZ-Name-Container'>Market Z</h1>
          </div>

          <div className='Search-bar-container'>
            <input type='text' placeholder='Buscar...' className='Search-bar' aria-label='Buscar' />
          </div>
          <div className='Options-Container'>
            <div className='MKZ-Option-Container'>
              <img src={Control} alt='Control de videojuegos' className='MkZ-Icons' />
              <h4 className='MKZ-Option-Txt'>Usados</h4>
              <img src={Guitar} alt='Guitarra eléctrica' className='MkZ-Icons' />
            </div>
            <div className='MKZ-Option-Container'>
              <img src={Paper1} alt='Publicidad impresa' className='MkZ-Icons' />
              <h4 className='MKZ-Option-Txt'>Publicidad</h4>
              <img src={Paper2} alt='Publicidad digital' className='MkZ-Icons' />
            </div>
          </div>
        </div>

        <div className='shopping-car-log-container'>
          <div className='shopping-car-container' onClick={handleCartView}>
            <img src={Carrito} alt='Carrito de compras' className='Cart-Icon' />
            <span className='car-items-number'>{cartItems.length}</span>
          </div>

          <div className='username-login-cont'>
            {user ? (
              <div className='user-info'>
                <span>{user.username.charAt(0).toUpperCase() + user.username.slice(1)}</span>
                <button onClick={handleLogout} className='logout-btn' aria-label='Cerrar sesión'>X</button>
              </div>
            ) : (
              <>
                <button onClick={() => handleAuthView('login')} className='username-login'>
                  Ingresar
                </button>
                <button onClick={() => handleAuthView('register')} className='username-login'>
                  Registrarse
                </button>
              </>
            )}
          </div>
        </div>

      </header>
      {showCart ? (
        <ShoppingCart cartItems={cartItems} setShowCart={setShowCart} />
      ) : user?.isAdmin ? (
        <AddProduct />
      ) : (
        <Items setCartItems={setShowCart} />
      )}
    </div>
  );
};

export default MainPage;
